import { useTheme } from "@hooks";
import { constants, spacing } from "@layout";
import { CSSProperties } from "react";

export const useStyles = () => {
  const { theme } = useTheme();

  const styles: Record<string, CSSProperties> = {
    listContent: {
      paddingBottom: spacing.xxxl,
    },
    sectionHeader: {
      paddingTop: spacing.l,
      paddingBottom: spacing.xs,
    },
    sectionHeaderText: {
      color: theme.text.secondary,
      fontSize: "0.85em",
      fontWeight: 500,
    },
    card: {
      backgroundColor: theme.card.background,
      borderRadius: constants.radius.view,
      padding: spacing.m,
      marginBottom: spacing.xs,
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      cursor: "pointer",
      userSelect: "none",
    },
    cardContent: {
      flex: 1,
      minWidth: 0,
    },
    dateText: {
      color: theme.text.secondary,
      fontSize: "0.85em",
    },
    unreadDot: {
      width: 8,
      height: 8,
      borderRadius: 4,
      backgroundColor: theme.documents.unread,
      marginLeft: spacing.s,
      flexShrink: 0,
    },
    emptyContainer: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      textAlign: "center",
      padding: `0 ${spacing.m}px`,
      minHeight: 200,
    },
  };

  return styles;
};
